export default __webpack_public_path__ + "static/media/chateau.64e79eb6.jpg";